import React from 'react';
import { LoginScreen } from './components/login-screen';
import { ErrorScreen } from './components/error-screen';
import { LoadingOverlay } from './components/loading-overlay/loading-overlay';
/**
 * Props for the `ProxyLogin` component.
 *
 * @typedef {Object} ProxyLoginProps
 * @property {HttpClientT<unknown>} httpClient - A function for making HTTP requests, which takes an optional URL and request options, and returns a promise with the result.
 * @property {UserConfigurationT | null} config - Configuration object for the provider, or `null` if not available. Provides settings or parameters needed for the login process.
 * @property {string} authUrl - The URL used for user authentication.
 * @property {LoginErrorT | null} [error] - Optional object containing error details related to the login process. Includes error message and description, or `null` if no error.
 * @property {(value: boolean) => void} setIsLoggedIn - Function to update the login state of the component. Accepts a boolean value indicating whether the user is logged in.
 * @property {({ themeAccent }: { themeAccent: 'light' | 'dark'}) => React.JSX.Element} [customLogos] - Optional custom logo component to display in the login screen.
 * @property {React.ReactElement} customLoadingOverlay - Optional element to display custom loading state
 */
export const ProxyLogin = ({ httpClient, config, authUrl = 'https://api.dev.icp.invent.us/v1/pea', cdnUrl = 'https://inventwidgetstorage.z19.web.core.windows.net/icons/crm-providers', setIsLoggedIn, customLogo, error, availableProviders, customLoadingOverlay }) => {
    if (error) {
        return React.createElement(ErrorScreen, { error: error });
    }
    if (!config) {
        return customLoadingOverlay !== null && customLoadingOverlay !== void 0 ? customLoadingOverlay : React.createElement(LoadingOverlay, null);
    }
    if (config.configurationId) {
        return (React.createElement(LoginScreen, { httpClient: httpClient, providerType: config.providerType, title: config.title, configurationId: config.configurationId, authUrl: authUrl, setIsLogged: setIsLoggedIn, customLogo: customLogo, availableProviders: availableProviders, cdnUrl: cdnUrl }));
    }
    return null;
};
